<div
  class="icon-container {{ styleClass }}"
  a360Icon
  [attr.aut-id]="autId ? autId : null"
  [icon]="icon + '.' + ext"
  [fullIconPath]="fullIconPath"
  [text]="text"
  [width]="width"
  [height]="height"
  [viewBox]="viewBox"
  [isHoverEnable]="isHoverEnable"
  [color]="color"
  [attr.style]="'fill: ' + color"
  [hoverColor]="hoverColor"
  [attr.aria-label]="isButton ? iconTitle : null"
  [attr.role]="isButton ? 'button' : null"
  [attr.tabindex]="shouldHideTabIndex ? null : isButton ? 0 : -1"
  >
  <div class="icon-wrapper" [ngStyle]="style">
    @switch (icon) {
      @case ('ac-type-0') {
        <ac-type-0-icon></ac-type-0-icon>
      }
      @case ('ac-type-1') {
        <ac-type-1-icon></ac-type-1-icon>
      }
      @case ('ac-type-2') {
        <ac-type-2-icon></ac-type-2-icon>
      }
      @case ('ac-type-3') {
        <ac-type-3-icon></ac-type-3-icon>
      }
      @case ('ac-type-4') {
        <ac-type-4-icon></ac-type-4-icon>
      }
      @case ('ac-type-5') {
        <ac-type-5-icon></ac-type-5-icon>
      }
      @case ('ac-type-6') {
        <ac-type-6-icon></ac-type-6-icon>
      }
      @case ('ac-type-7') {
        <ac-type-7-icon></ac-type-7-icon>
      }
      @case ('ac-type-8') {
        <ac-type-8-icon></ac-type-8-icon>
      }
      @case ('ac-type-9') {
        <ac-type-9-icon></ac-type-9-icon>
      }
      @case ('ac-type-10') {
        <ac-type-10-icon></ac-type-10-icon>
      }
      @case ('ac-type-11') {
        <ac-type-11-icon></ac-type-11-icon>
      }
      @case ('ac-type-null') {
        <ac-type-null-icon></ac-type-null-icon>
      }
      @case ('doc-format-avi-file') {
        <doc-format-avi-file-icon></doc-format-avi-file-icon>
      }
      @case ('doc-format-bmp-file') {
        <doc-format-bmp-file-icon></doc-format-bmp-file-icon>
      }
      @case ('doc-format-doc-file') {
        <doc-format-doc-file-icon></doc-format-doc-file-icon>
      }
      @case ('doc-format-docx-file') {
        <doc-format-docx-file-icon></doc-format-docx-file-icon>
      }
      @case ('doc-format-gif-file') {
        <doc-format-gif-file-icon></doc-format-gif-file-icon>
      }
      @case ('doc-format-jpeg-file') {
        <doc-format-jpeg-file-icon></doc-format-jpeg-file-icon>
      }
      @case ('doc-format-jpg-file') {
        <doc-format-jpg-file-icon></doc-format-jpg-file-icon>
      }
      @case ('doc-format-mov-file') {
        <doc-format-mov-file-icon></doc-format-mov-file-icon>
      }
      @case ('doc-format-mp3-file') {
        <doc-format-mp3-file-icon></doc-format-mp3-file-icon>
      }
      @case ('doc-format-mp4-file') {
        <doc-format-mp4-file-icon></doc-format-mp4-file-icon>
      }
      @case ('doc-format-pdf-file') {
        <doc-format-pdf-file-icon></doc-format-pdf-file-icon>
      }
      @case ('doc-format-png-file') {
        <doc-format-png-file-icon></doc-format-png-file-icon>
      }
      @case ('doc-format-ppt-file') {
        <doc-format-ppt-file-icon></doc-format-ppt-file-icon>
      }
      @case ('doc-format-pptx-file') {
        <doc-format-pptx-file-icon></doc-format-pptx-file-icon>
      }
      @case ('doc-format-txt-file') {
        <doc-format-txt-file-icon></doc-format-txt-file-icon>
      }
      @case ('doc-format-wmv-file') {
        <doc-format-wmv-file-icon></doc-format-wmv-file-icon>
      }
      @case ('doc-format-wpd-file') {
        <doc-format-wpd-file-icon></doc-format-wpd-file-icon>
      }
      @case ('doc-format-xls-file') {
        <doc-format-xls-file-icon></doc-format-xls-file-icon>
      }
      @case ('doc-format-xlsx-file') {
        <doc-format-xlsx-file-icon></doc-format-xlsx-file-icon>
      }
      @case ('academic-cap') {
        <academic-cap-icon></academic-cap-icon>
      }
      @case ('arrow-down') {
        <arrow-down-icon></arrow-down-icon>
      }
      @case ('arrow-to-right') {
        <arrow-to-right-icon></arrow-to-right-icon>
      }
      @case ('ban') {
        <ban-icon></ban-icon>
      }
      @case ('bell') {
        <bell-icon></bell-icon>
      }
      @case ('bolt') {
        <bolt-icon></bolt-icon>
      }
      @case ('burger-menu') {
        <burger-menu-icon></burger-menu-icon>
      }
      @case ('cad-import') {
        <cad-import-icon></cad-import-icon>
      }
      @case ('calendar-alt') {
        <calendar-alt-icon></calendar-alt-icon>
      }
      @case ('calendar-check') {
        <calendar-check-icon></calendar-check-icon>
      }
      @case ('calendar') {
        <calendar-icon></calendar-icon>
      }
      @case ('caret-down') {
        <caret-down-icon></caret-down-icon>
      }
      @case ('caret-up') {
        <caret-up-icon></caret-up-icon>
      }
      @case ('check-thin') {
        <check-thin-icon></check-thin-icon>
      }
      @case ('checkmark') {
        <checkmark-icon></checkmark-icon>
      }
      @case ('clip') {
        <clip-icon></clip-icon>
      }
      @case ('clipboard') {
        <clipboard-icon></clipboard-icon>
      }
      @case ('clock') {
        <clock-icon></clock-icon>
      }
      @case ('comment') {
        <comment-icon></comment-icon>
      }
      @case ('cross') {
        <cross-icon></cross-icon>
      }
      @case ('dashboard') {
        <dashboard-icon></dashboard-icon>
      }
      @case ('double-arrow-right') {
        <double-arrow-right-icon></double-arrow-right-icon>
      }
      @case ('edit') {
        <edit-icon></edit-icon>
      }
      @case ('excel-file') {
        <excel-file-icon></excel-file-icon>
      }
      @case ('exclamation-circle') {
        <exclamation-circle-icon></exclamation-circle-icon>
      }
      @case ('exclamation-mark') {
        <exclamation-mark-icon></exclamation-mark-icon>
      }
      @case ('external-link') {
        <external-link-icon></external-link-icon>
      }
      @case ('eye') {
        <eye-icon></eye-icon>
      }
      @case ('eye-off') {
        <eye-off-icon></eye-off-icon>
      }
      @case ('file') {
        <file-icon></file-icon>
      }
      @case ('filled-question') {
        <filled-question-icon></filled-question-icon>
      }
      @case ('filter') {
        <filter-icon></filter-icon>
      }
      @case ('folder') {
        <folder-icon></folder-icon>
      }
      @case ('folder-blue') {
        <folder-icon-blue></folder-icon-blue>
      }
      @case ('gear') {
        <gear-icon></gear-icon>
      }
      @case ('gears') {
        <gears-icon></gears-icon>
      }
      @case ('high-five') {
        <high-five-icon></high-five-icon>
      }
      @case ('info') {
        <info-icon></info-icon>
      }
      @case ('info-thin') {
        <info-thin-icon></info-thin-icon>
      }
      @case ('lock') {
        <lock-icon></lock-icon>
      }
      @case ('logout') {
        <logout-icon></logout-icon>
      }
      @case ('mail') {
        <mail-icon></mail-icon>
      }
      @case ('map-mark') {
        <map-mark-icon></map-mark-icon>
      }
      @case ('medal') {
        <medal-icon></medal-icon>
      }
      @case ('moon') {
        <moon-icon></moon-icon>
      }
      @case ('no-chose') {
        <no-chose-icon></no-chose-icon>
      }
      @case ('note') {
        <note-icon></note-icon>
      }
      @case ('pdf-file') {
        <pdf-file-icon></pdf-file-icon>
      }
      @case ('phone') {
        <phone-icon></phone-icon>
      }
      @case ('power-dms-logo') {
        <power-dms-logo-icon></power-dms-logo-icon>
      }
      @case ('printer') {
        <printer-icon></printer-icon>
      }
      @case ('redo') {
        <redo-icon></redo-icon>
      }
      @case ('search') {
        <search-icon></search-icon>
      }
      @case ('signal') {
        <signal-icon></signal-icon>
      }
      @case ('sort-arrow') {
        <sort-arrow-icon></sort-arrow-icon>
      }
      @case ('sort-arrow-down') {
        <sort-arrow-down-icon></sort-arrow-down-icon>
      }
      @case ('spinner') {
        <spinner-icon></spinner-icon>
      }
      @case ('star') {
        <star-icon></star-icon>
      }
      @case ('sparkles') {
        <sparkles-icon></sparkles-icon>
      }
      @case ('sun') {
        <sun-icon></sun-icon>
      }
      @case ('tasks') {
        <tasks-icon></tasks-icon>
      }
      @case ('tools') {
        <tools-icon></tools-icon>
      }
      @case ('trash-bin') {
        <trash-bin-icon></trash-bin-icon>
      }
      @case ('user') {
        <user-icon></user-icon>
      }
      @case ('user-folder') {
        <user-folder-icon></user-folder-icon>
      }
      @case ('users') {
        <users-icon></users-icon>
      }
      @case ('warning') {
        <warning-icon></warning-icon>
      }
      @case ('warning-thin') {
        <warning-thin-icon></warning-thin-icon>
      }
      @case ('group') {
        <group-icon></group-icon>
      }
      @case ('arrow-left') {
        <arrow-left-icon></arrow-left-icon>
      }
      @case ('arrow-right') {
        <arrow-right-icon></arrow-right-icon>
      }
    }
  </div>
</div>
